//@ts-nocheck
import {
  Divider,
  Dropdown,
  Button,
  Form,
  Grid,
  Input,
  Text,
  Popup,
} from '@wework/dieter-ui'
import React, { useEffect, useState } from 'react'
import { useSidebar } from '../../hoc/withSidebar'
import { Lock } from '../Icons'
import EditPhysicalSpaceMeetingRoom from './EditPhysicalSpaceMeetingRoom'
import EditPhysicalSpaceOffice from './EditPhysicalSpaceOffice'
import EditProductMeetingRoomAttributes from './EditProductMeetingRoomAttributes'
import SATextHolder from './SATextHolder'

export default function EditProductAttributes({
  space,
  roomData,
  setRoomData,
}) {
  if (!roomData) {
    return null
  }

  const getSeatCount = space => {
    let seatCount = 0
    if (space.roomType == 'DEDICATED DESK') {
      seatCount = space.metrics?.desks
    } else {
      if (space.inventoryData?.relationships.length > 0) {
        seatCount = space.inventoryData?.relationships[0]?.seat_count
      }
    }
    return seatCount
  }

  return (
    <>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="Total number of seats?"
              text="How many seats are available for this inventory?. To change the capacity, please request it here."
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Group widths="equal">
              <Form.Field
                label="Seat count"
                control={Input}
                size="small"
                value={
                  space.inventoryData?.relationships.length > 0
                    ? space.inventoryData?.relationships[0]?.seat_count.toString()
                    : '0'
                }
                outline
                fluid
                className="noOpacity"
                style={{ marginBottom: 24 }}
                icon={
                  <div
                    style={{
                      position: 'absolute',
                      right: 5,
                      top: 10,
                      cursor: 'pointer',
                    }}
                  >
                    <Button
                      icon={<Lock />}
                      style={{ padding: 0, background: 'white' }}
                    />
                  </div>
                }
              />
              <Form.Field
                label="Capacity"
                control={Input}
                size="small"
                disabled={!space.reservable?.capacity.toString()}
                value={
                  !space.reservable?.capacity?.toString()
                    ? '0'
                    : space.reservable?.capacity.toString()
                }
                className="noOpacity"
                outline
                fluid
                style={{ marginBottom: 24 }}
                icon={
                  <div
                    style={{
                      position: 'absolute',
                      right: 5,
                      top: 10,
                      cursor: 'pointer',
                    }}
                  >
                    <Button
                      icon={<Lock />}
                      style={{ padding: 0, background: 'white' }}
                    />
                  </div>
                }
              />
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <SATextHolder
                title="Total size of the inventory"
                text="How big is the total space of this inventory? To change the size, please request it here."
              />
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="Size in ft"
              control={Input}
              outline
              value={
                space.inventoryData?.relationships.length > 0
                  ? space.inventoryData?.relationships[0]?.usable_sqft.toString()
                  : '0'
              }
              icon={
                <div
                  style={{
                    position: 'absolute',
                    right: 5,
                    top: 10,
                    cursor: 'pointer',
                  }}
                >
                  <Button
                    icon={<Lock />}
                    style={{ padding: 0, background: 'white' }}
                  />
                </div>
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <SATextHolder
                title="Total price of the inventory"
                text="How much is the inventory monthly price? To change the size, please request it here."
              />
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="Price"
              control={Input}
              outlineß
              value={space.reservable?.displayPrice}
              icon={
                <div
                  style={{
                    position: 'absolute',
                    right: 5,
                    top: 10,
                    cursor: 'pointer',
                  }}
                >
                  <Button
                    icon={<Lock />}
                    style={{ padding: 0, background: 'white' }}
                  />
                </div>
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}
